import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { notification } from "antd";

export default function PushNavListener() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const go = (url) => {
      try {
        const u = new URL(url, window.location.origin);
        const path = u.pathname + u.search + u.hash;

        // If already on that exact URL, force reload
        if (location.pathname + location.search + location.hash === path) {
          window.location.href = path;
          return;
        }

        navigate(path);
      } catch {
        navigate(url);
      }
    };

    const handler = (event) => {
      const msg = event.data;

      if (msg?.type === "NAVIGATE" && msg.url) {
        go(msg.url);
        return;
      }

      // Optional in-app banner if you ever re-enable PUSH_RECEIVED
      if (msg?.type === "PUSH_RECEIVED" && msg.url) {
        notification.open({
          message: msg.title || "NextGen VR",
          description: msg.body || "Open booking",
          onClick: () => go(msg.url),
        });
      }
    };

    navigator.serviceWorker.addEventListener("message", handler);
    return () => navigator.serviceWorker.removeEventListener("message", handler);
  }, [navigate, location]);

  return null;
}
